import React from 'react';
import {WrongSVGWrap} from './styles.js';

type WrongSVGTypes = {
    clickedBtn?: string
}

const WrongSVG: React.FC<WrongSVGTypes> = () => {
    return (
        <WrongSVGWrap
            viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <path d="M 10 10 L 90 90"></path>
            <path d="M 90 10 L 10 90"></path>
        </WrongSVGWrap>
    )
}

export default WrongSVG